module.exports = {"id":"164985","name":"Cyril Théréau","rating":"77","photo":"./data/images/photos/3/164985.png","club":{"name":"Fiorentina","logo":"./data/images/clubs/Fiorentina.png"},"positions":["AG","ATT"],"photoFolderIndex":3}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/CyrilThereau0.json
// module id = 892
// module chunks = 0